import request from '@/utils/request'

export function getMessageList() {
  return request({
    url: '/message/list',
    method: 'post',
  })
}

export function getMessagePage(data) {
  return request({
    url: '/message/pages',
    params: {
      page: data.pageNum,
      size: data.pageSize,
    },
    method: 'post',
  })
}

export function delMessage(msgId) {
  return request({
    url: `/message/delete?msgId=${msgId}`,
    method: 'post',
  })
}

export function delAllMessage() {
  return request({
    url: '/message/deleteAll',
    method: 'post',
  })
}

export function readMessage(msgId) {
  return request({
    url: `/message/read?msgId=${msgId}`,
    method: 'post',
  })
}
export function readAllMessage() {
  return request({
    url: `/message/readAll`,
    method: 'post',
  })
}
